import React from 'react';
import List from '@mui/icons-material/List';
import DashboardIcon from '@mui/icons-material/Dashboard';

const menuItems = [
  {
    icon: <DashboardIcon />,
    text: 'NavBar.Dashboard',
    path: '/dashboard',
    name: 'Dashboard'
  },
  {
    icon: <List />,
    text: 'NavBar.Settings',
    path: '/settings',
    name: 'Settings'
  }
];

export default menuItems;
